// Seelie Court pure helper. No React, no Three.js.
//
// ── Codex (Seelie Court, Minion) ──
//   "At the start of your turn, players draw a spell for each Faerie in
//   the realm."
//
// on_turn_start trigger. The count is the number of in-play cards
// matching the filter (subtype Faerie, ANY controller); EVERY player
// draws that many spells. The existing dynamic-count `draw` op only
// draws for the source's controller, so this op fans the same count to
// every seat.
//
// Host adapter contract:
//   resolveScope(sourceCard, scope, args): card[]. Global Faerie scan
//   drawSpellsFor(controller, count): number. Draws `count`
//     spells into `controller`'s hand; returns how many were drawn.
//   logAction(key, values?): void

import { msg } from '../../../../logMessage';

const SEATS = ['p1', 'p2'];

/**
 * Resolve Seelie Court's start-of-turn draw.
 *
 * @param {object} sourceCard
 * @param {object} args  { filter, source?: 'spell' }
 * @param {object} host
 */
export function applyAllPlayersDrawPerScope(sourceCard, args, host) {
  const filter = args?.filter || { subtype: 'Faerie' };
  const matches = host.resolveScope(
    sourceCard,
    { where: 'global' },
    { filter, exclude_self: false },
  );
  const count = matches.length;
  if (count <= 0) {
    host.logAction('{source}: no Faeries in the realm', { source: sourceCard.name || msg('Seelie Court') });
    return;
  }
  for (const seat of SEATS) {
    const drawn = host.drawSpellsFor(seat, count);
    if (drawn > 0) {
      host.logAction('{source}: {who} draws {n} for the Faeries', {
        source: sourceCard.name || msg('Seelie Court'),
        who: seat === 'p1' ? msg('Player 1') : msg('Player 2'),
        n: drawn,
      });
    }
  }
}
